'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.nl-root {\n  color: #333333;\n  text-decoration: unset;\n}\n.nl-root:hover {\n  color: #1D66DD;\n}\n.nl-root .icon {\n  margin-right: calc(0.5 * 1rem);\n  font-size: calc(0.75 * 1rem);\n}");
//# sourceMappingURL=NavLink.scss.js.map
